<template>
  <div>
    <h2 :class="{upload_titile:true,input_title_hq:true,red_required:uploadRequire}">{{uploadTitle}}</h2>
    <div class="upload-content-box">
      <van-uploader v-model="uploadImageModel"  :max-size="10 * 1024 * 1024" @oversize="onOversize"
       :max-count="uploadMaxCount"
       :after-read="uploadAfterRead" :before-delete="deleteUploadImg" :before-read="beforeRead"></van-uploader>
    </div>
  </div>
</template>
<script>
import Compressor from 'compressorjs';
import { Toast } from "vant"
import api from "@/fetch/api"
export default {
  data(){
    return {
      upload_image:[],
      uploadImageModel:[],
      uploadImageArr:[],
      uploadUrlArr:[],
      uploadImageArrNew:[],
    }
  },
  props:{
    uploadTitle: {
      type: String,
      default: ""
    },
    yyid: {
      type: String,
      default: ""
    },
    uploadRequire:{
      type: Boolean,
      default: true
    },
    uploadMultiple:{
      type: Boolean,
      default: false
    },
    uploadMaxCount:{
      type: String,
      default: "-"
    },
    uploadType:{
      type:String,
      default:""
    },
  },
  methods:{
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize(){
      Toast('文件大小不能超过 10Mb');
    },
    uploadAfterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';

      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      switch (this.uploadType) {
        case "deliveryPic":
        formData.append("dzydpics", file.file);
        formData.append("yyid", this.yyid);
          break;
        case "deliveryxhPic":
          formData.append("dzydpics", file.file);
          formData.append("yyid", this.yyid);
          break;
      }

      api.uploadPicCommon(this.uploadType, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data.dzydurl;
          var uploadImageArr = that.uploadImageArr;
          var uploadUrlArr = that.uploadUrlArr;

          var imageDataArr = imageData.split(',');
          switch (that.uploadType) {
            case "deliveryPic":
            for (var i = 0; i < imageDataArr.length; i++) {
              if (uploadImageArr.length > 0) {
                uploadImageArr.push({
                  'url': weburl + '/' + imageDataArr[i]
                });
                uploadUrlArr.push(imageDataArr[i]);
              } else {
                uploadImageArr = imageDataArr[i] ? [{
                  url: weburl + '/' + imageDataArr[i]
                }] : [];
                uploadUrlArr = imageDataArr[i] ? [imageDataArr[i]] : [];
              }
            }

            that.uploadImageModel = that.uploadImageArr = uploadImageArr;
            that.uploadUrlArr = uploadUrlArr;
            that.$emit('getUploadInfo',uploadUrlArr);
            break;
            case "deliveryxhPic":
              for (var j = 0; j < imageDataArr.length; j++) {
                if (uploadImageArr.length > 0) {
                  uploadImageArr.push({
                    'url': weburl + '/' + imageDataArr[j]
                  });
                  uploadUrlArr.push(imageDataArr[j]);
                } else {
                  uploadImageArr = imageDataArr[j] ? [{
                    url: weburl + '/' + imageDataArr[j]
                  }] : [];
                  uploadUrlArr = imageDataArr[j] ? [imageDataArr[j]] : [];
                }
              }

              that.uploadImageModel = that.uploadImageArr = uploadImageArr;
              that.uploadUrlArr = uploadUrlArr;
              that.$emit('getUploadxhInfo',uploadUrlArr);
              break;
          }

        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    deleteUploadImg(file) {
      var that = this;
      const weburl = that.GLOBAL.weburl;
      var uploadImageArr = that.uploadImageArr;
      var uploadImageArrNew = [];
      var uploadUrlArrNew = [];
      for (var i = 0; i < uploadImageArr.length; i++) {
        if (uploadImageArr[i].url != file.url) {
          uploadImageArrNew.push(uploadImageArr[i]);
          var path = uploadImageArr[i].url.replace(weburl, '');
          uploadUrlArrNew.push(path);
        }
      }
      that.uploadImageModel = that.uploadImageArr = uploadImageArrNew;
      that.uploadUrlArr = uploadUrlArrNew;
      that.$emit('getUploadInfo',this.uploadUrlArr);
    },
  }
}
</script>
<style lang="scss" scoped>
.upload_titile {
    padding: 0.675rem 1rem;
}

.input_title_hq {
  font-size: 1rem;
}

.red_required::before {
  position: absolute;
  left: 8px;
  color: #ee0a24;
  font-size: 14px;
  content: '*';
}

.upload-content-box {
    margin-left: 1rem;
}

</style>
